import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { UserId, Uuid } from '../Base';
import { RepositoryElement } from '../Repository';

export enum SubscriptionType {
  Monthly = 'monthly',
  Yearly = 'yearly',
  Permanent = 'permanent',
}

export type SpaceMembershipTierSubscriptionJson<T = number> = {
  readonly tierId: Uuid; //identifier
  readonly classroomId: Uuid; //identifier
  readonly userId: UserId; // identifier
  createdAt: T;
  lastModifiedAt: T;
  subscribedAt: T;
  expiredAt?: T;
  subscriptionType: SubscriptionType;
  willAutoRenew?: boolean;
  lastRewardRedemptionId: string;
};

export class SpaceMembershipTierSubscription
  extends RepositoryElement
  implements SpaceMembershipTierSubscriptionJson<Date>
{
  readonly tierId!: Uuid; //identifier
  readonly classroomId!: Uuid; //identifier
  readonly userId!: UserId; // identifier
  createdAt!: Date;
  lastModifiedAt!: Date;
  subscribedAt!: Date;
  expiredAt!: Date;
  subscriptionType!: SubscriptionType;
  willAutoRenew?: boolean | undefined;
  lastRewardRedemptionId!: string;

  constructor(inventory: SpaceMembershipTierSubscriptionJson<Date | number>) {
    super();
    Object.assign(this, deepTransformTimestamp(inventory));
  }

  id(): string {
    return `${this.classroomId}_${this.userId}_${this.tierId}`;
  }

  toJSON(): SpaceMembershipTierSubscriptionJson {
    return deepTransformDate(
      this,
    ) as unknown as SpaceMembershipTierSubscriptionJson;
  }

  get isActivated(): boolean {
    const now = new Date();
    return now > this.subscribedAt && now < this.expiredAt;
  }

  get isExpired(): boolean {
    const now = new Date();
    return now > this.expiredAt;
  }
}
